import { render, staticRenderFns } from "./page.vue?vue&type=template&id=65805278&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=65805278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65805278",
  null
  
)

export default component.exports